import { render, staticRenderFns } from "./gongxu.vue?vue&type=template&id=5213ab92&"
import script from "./gongxu.vue?vue&type=script&lang=js&"
export * from "./gongxu.vue?vue&type=script&lang=js&"
import style0 from "./gongxu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports